

















import Vue from 'vue'

const priorities: number[] = []

export default Vue.extend({
  name: 'UiButton',
  data () {
    return {priorities}
  },
  props: {
    to: {},
    priority: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: '' // xs - extra small, sm - small, lg - large, xl - extra large
    },
    disabled: {
      type: Boolean,
      default: false
    },
    danger: {
      type: Boolean,
      default: false
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: ''
    }
  },
  methods: {
    emitClick (event: UIEvent) {
      if (this.to) {
        this.$router.push(this.to)
      }
      this.$emit('click', event)
    }
  },
  created () {
    this.priorities.push(this.priority)
  },
  beforeDestroy () {
    this.priorities.splice(this.priorities.indexOf(this.priority), 1)
  },
  computed: {
    highestPriority (): number {
      return Math.max.apply(Math, this.priorities);
    },
    highPriority (): boolean {
      return this.priority >= 0 && this.highestPriority === this.priority
    }
  }
})
